<template>
  <el-dialog
      title="定价辅助计算器"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      append-to-body
      width="1200px"
      top="6vh"
  >
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" size="medium">
      <div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
        <div class="item_title">
          采购成本
        </div>
        <div class="item_title">
          平台成本
        </div>
        <div class="item_title">
          广告促销
        </div>
      </div>
      <div class="form_box">
        <div class="item_box_form">
          <el-form-item label="采购单价：" prop="caigoudanjia">
            <el-input v-model="ruleForm.caigoudanjia" class="item_input" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">CNY</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="类目佣金：">
            <el-input v-model="ruleForm.leimuyongjin" class="item_input" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="广告：" prop="guanggao">
            <el-input v-model="ruleForm.guanggao" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="采购运费：">
            <el-input v-model="ruleForm.caigouyunfei" class="item_input" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">CNY</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="提现手续：" prop="tixianshouxu">
            <el-input v-model="ruleForm.tixianshouxu" disabled >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="促销活动：" prop="cuxiaohuodong">
            <el-input v-model="ruleForm.cuxiaohuodong" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
        <div class="item_title">
          国际运费
        </div>
      </div>
      <div class="form_box">
        <div class="item_box_form">
          <el-form-item label="重量：" prop="zhongliang">
            <el-input v-model="ruleForm.zhongliang" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">KG</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="净利率：" prop="jinglilv">
            <el-input v-model="ruleForm.jinglilv" class="item_input" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
        </div>
        <div class="item_box_form">
          <el-form-item label="运费单价：" prop="yunfeidanjia">
            <el-input v-model="ruleForm.yunfeidanjia" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">CNY/KG</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-form-item label="售价：" prop="shoujia">
            <el-input v-model="ruleForm.shoujia" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">PLN</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_box_form">
          <el-button type="primary" @click="jisuan">计  算</el-button>
        </div>
        <div class="item_box_form">
          <el-form-item label="挂号费：" prop="guahaofei">
            <el-input v-model="ruleForm.guahaofei" oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
              <template slot="append">CNY</template>
            </el-input>
          </el-form-item>
        </div>
      </div>

      <div style="display: flex;width: 100%;padding: 0 10px;margin-bottom: 15px">
        <div class="item_title">
          计算过程
        </div>
      </div>
      <el-input
          class="input_area"
          type="textarea"
          :rows="5"
          v-model="ruleForm.beizhuguocheng"/>
    </el-form>
    <span slot="footer" style="margin-top: 60px">
					<el-button type="primary" v-if="isshowBeizhu" @click="beizhu">备注过程</el-button>
					<el-button type="primary" @click="gengxinshoujia">更新售价</el-button>
					<el-button @click="dialogVisible = false">关  闭</el-button>
  			</span>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl,ajaxGet } from '@/api/api/api'

export default {
  name: 'dingjiaComp',
  props: {
    // score: {
    // 	type: Array,
    // 	default() {
    // 		return [0,0,0,0];
    // 	},
    // }
  },
  data() {
    return {
      //是否展示备注按钮
      isshowBeizhu: true,
      yongjinOptions: [],
      zhongliangOptions: [],
      //问号图标的地址
      urlQueImg: require('@/assets/images/wenhao.png'),
      //提示bug弹窗
      dialogVisible: false,
      bolanhuilv: 0,
      ruleForm: {
        caigoudanjia: 0,
        leimuyongjin: 0,
        guanggao: 0,
        caigouyunfei: 0,
        tixianshouxu: 0.7,
        cuxiaohuodong: 0,
        zhongliang: 0,
        jinglilv: 20,
        yunfeidanjia: 0,
        shoujia: 0,
        guahaofei: 0,
        beizhuguocheng: ''
      },
      commission: undefined
    }
  },
  created() {
    //获取分类重量运费列表
    const API = Baseurl + 'ozonWeightFreightController/getOzonWeightFreightList'
    ajaxGet(API).then((res) => {
      const {code, data} = res.data
      if (code === 200) {
        this.zhongliangOptions = data
      }
    })
    //获取佣金比例列表
    const API2 = Baseurl + 'ozonCategoryCommissionRateController/getOzonCategoryCommissionRateList'
    ajaxGet(API2).then((res) => {
      const {code, data} = res.data
      if (code === 200) {
        let yongjinOptions = data.map(item => {
          item.label = item.categoryGroup + '_' + item.category + ' ' + item.commission
          item.value = item.id
          return item
        })
        this.yongjinOptions = yongjinOptions
      }
    })
    //获取lilv
    const API3 = Baseurl + 'rateController/getRateByCurrencyCode'
    let params = {
      "currencyCode": "PLN"
    }
    ajaxPost(API3, params).then((res) => {
      const {code, data} = res.data
      if (code === 200) {
        this.bolanhuilv = parseFloat(data.exchangeRate)
      }
    })
  },
  methods: {
    //重置定价
    resetDingjia() {
      this.ruleForm = {
        caigoudanjia: 0,
        leimuyongjin: 0,
        guanggao: 0,
        caigouyunfei: 0,
        tixianshouxu: 0.7,
        cuxiaohuodong: 0,
        zhongliang: 0,
        jinglilv: 20,
        yunfeidanjia: 0,
        shoujia: 0,
        guahaofei: 0,
        beizhuguocheng: ''
      }
    },
    changeYongjin(val) {
      if (val) {
        this.commission = this.yongjinOptions.filter(item => {
          return item.id == val
        })[0].commission
      }
    },
    changeZhongliang(val) {
      //给预估费用赋值
      this.ruleForm.yunfeidanjia = this.zhongliangOptions.filter(item => {
        return item.id == val
      })[0].freight

    },
    jisuan() {
      let caigoudanjia = this.ruleForm.caigoudanjia ? this.ruleForm.caigoudanjia / 1 : 0
      let leimuyongjin = this.commission ? this.commission : 0
      let guanggao = this.ruleForm.guanggao ? this.ruleForm.guanggao : 0
      let caigouyunfei = this.ruleForm.caigouyunfei ? this.ruleForm.caigouyunfei / 1 : 0
      let tixianshouxu = this.ruleForm.tixianshouxu ? this.ruleForm.tixianshouxu : 0
      let cuxiaohuodong = this.ruleForm.cuxiaohuodong ? this.ruleForm.cuxiaohuodong : 0
      let zhongliang = this.ruleForm.zhongliang ? this.ruleForm.zhongliang / 1 : 0
      let jinglilv = this.ruleForm.jinglilv ? this.ruleForm.jinglilv / 1 : 0
      let yunfeidanjia = this.ruleForm.yunfeidanjia ? this.ruleForm.yunfeidanjia / 1 : 0
      let guahaofei = this.ruleForm.guahaofei ? this.ruleForm.guahaofei / 1 : 0
      this.ruleForm.shoujia = (parseFloat((caigoudanjia + caigouyunfei + (yunfeidanjia * zhongliang) + guahaofei) /
          (1 - (leimuyongjin / 100) - (tixianshouxu / 100) - (guanggao / 100) - (cuxiaohuodong / 100) - (jinglilv / 100))) / this.bolanhuilv).toFixed(2)

      this.ruleForm.beizhuguocheng =
          (this.ruleForm.shoujia) + 'PLN = (' + caigoudanjia + ' + ' + caigouyunfei + ' + ' + yunfeidanjia
          + ' * ' + zhongliang + ' + ' + guahaofei + ')  / (1 - ' + leimuyongjin / 100 + ' - ' + (tixianshouxu / 100).toFixed(3) + ' - ' + guanggao / 100 + ' - ' +
          cuxiaohuodong / 100 + ' - ' + jinglilv / 100 + ')/' + this.bolanhuilv + '\n' +
          '售价 =（采购单价 + 采购运费 + 重量 * 运费单价 + 挂号费） / （1 - 类目佣金 - 提现手续费 - 广告 - 促销 - 净利率）/汇率\n' +
          '采购单价 = ' + caigoudanjia + 'CNY\n' +
          '采购运费 = ' + caigouyunfei + 'CNY\n' +
          '运费单价 = ' + yunfeidanjia + 'CNY/KG\n' +
          '重量 = ' + zhongliang + 'CNY\n' +
          '挂号费 = ' + guahaofei + 'CNY\n' +
          '类目佣金 = ' + leimuyongjin + '%\n' +
          '提现手续费 = ' + tixianshouxu + '%\n' +
          '广告 = ' + guanggao + '%\n' +
          '促销 = ' + cuxiaohuodong + '%\n' +
          '净利率 = ' + jinglilv + '%\n' +
          'PLN汇率 = ' + this.bolanhuilv + '\n' +
          '售价 = ' + this.ruleForm.shoujia + 'PLN'
    },
    //备注过程
    beizhu() {
      this.$emit('changeReamrk', this.ruleForm.beizhuguocheng)
    },
    //更新售价
    gengxinshoujia() {
      if (!this.ruleForm.shoujia) {
        this.jisuan()
      }
      this.$emit('changeDingjia', this.ruleForm.shoujia)
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../ozon.less";

/deep/ .el-input-group__append {
  width: 50px;
  text-align: center;
  padding: 0 0;
}

/deep/ .el-form-item__label {
  font-size: 18px;
}

.form_box {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .item_box_form {
    width: calc(33% - 30px);
    padding-right: 30px;
  }
}

.item_title {
  width: 33%;
  border-left: 5px solid rgb(95, 175, 255);
  padding-left: 10px;
  font-size: 18px;
}

.input_area {
  width: calc(99% - 60px);
  margin-left: 30px;
  margin-top: 20px;
}
</style>
